import type { ReactNode } from "react";

export type DataTableColumn<T> = {
  key: string;
  header: ReactNode;
  render: (row: T) => ReactNode;
  width?: string;
  align?: "left" | "right" | "center";
};

/**
 * 唯一正式数据表格。主列表默认显示业务名称、状态、负责人、下一步与更新时间，不显示内部 ID。
 * 横向溢出只允许在表格容器内部滚动，不得撑破页面。
 */
export function DataTable<T>({ columns, rows, rowKey, rowActions, empty, ariaLabel }: {
  columns: Array<DataTableColumn<T>>;
  rows: T[];
  rowKey: (row: T) => string;
  rowActions?: (row: T) => ReactNode;
  empty?: ReactNode;
  ariaLabel: string;
}) {
  return <div className="data-table-wrap" role="region" aria-label={ariaLabel}>
    <table className="data-table">
      <thead>
        <tr>
          {columns.map((column) => <th key={column.key} style={column.width ? { width: column.width } : undefined} scope="col">{column.header}</th>)}
          {rowActions && <th className="data-table-actions-head" scope="col" aria-label="操作" />}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => <tr key={rowKey(row)}>
          {columns.map((column) => <td
            key={column.key}
            data-label={typeof column.header === "string" ? column.header : column.key}
            className={column.align ? `align-${column.align}` : undefined}
          >{column.render(row)}</td>)}
          {rowActions && <td className="data-table-actions" data-label="操作">{rowActions(row)}</td>}
        </tr>)}
      </tbody>
    </table>
    {rows.length === 0 && (empty ? <div className="data-table-empty">{empty}</div> : <div className="data-table-empty">当前没有记录。</div>)}
  </div>;
}
